import datamethods from '../services/datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../style/format.js'
export default{
    mixins:[datamethods,format],
    computed:{
      ...mapFields([
        'panels',
        'ticketType_Culinary',
        'ticketTypeList_Culinary',
        'tableList_Culinary',
        'tableNumber_Culinary',
        'guestName_Culinary',
        'employee_Culinary',
        'employeeList_Culinary',
        'prepAreas',
        'payIndexAfterToKitchen',
        'payAfterToKitchen',
        'isNewTicket',
        'selectedSplitGuest',
        'currentSeatNumber',
        'IsAdmin',
        'loggedInUser',
        'showTableMap'
       

    ]),
    getGuestTotals(){
        //console.log('get guest totals')
        var lasthadtotal=true
        var guestTotals = []

        for (let i = 1; i <= 20; i++) {
          var n = "Guest " + i
          var t = this.getGuestTotal(n)
          var p = this.getGuestTotalPaid(n)
          var d = this.due_byGuest(n)
          var c = this.change_byGuest(n)
          var g1 = {
              name:n,
              total:t,
              totalpaid:p,
              due:d,
              change:c,
              show:lasthadtotal || i==1 || i==2
          }

          guestTotals.push(g1)
          lasthadtotal=t>0
        }
        
        return guestTotals
      },
      ticketIsSplit(){
        var issplit=false
        if(this.ticket.lineItems!=undefined){
              this.ticket.lineItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.guestNumber!=null ){
                        issplit=true
                    }
                } 
            }
            return issplit
      },
      ticketIsSplit_byTicket(t){
        var issplit=false
        if(t.lineItems!=undefined){
              t.lineItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.guestNumber!=null ){
                        issplit=true
                    }
                } 
            }
            return issplit
      },
      seatedTextOverride(){
        
        if(window.SEATED_TEXT_OVERRIDE==undefined){return 'Seated'}
        else{return window.SEATED_TEXT_OVERRIDE}
      },
      showTakeout(){
        if(window.SHOW_TAKEOUT==undefined){return true}
        else{return window.SHOW_TAKEOUT}
      },
      hasKitchenAdmin(){
        if(window.HAS_KITCHEN_ADMIN==undefined){return false}
        else{return window.HAS_KITCHEN_ADMIN}
      },
      showSeatGuests(){
        if(window.SHOW_SEAT_GUESTS==undefined){return true}
        else{return window.SHOW_SEAT_GUESTS}
      },
      showSeatNumbers(){
        
        if(window.SHOW_SEAT_NUMBERS==undefined){return false}
        else{return window.SHOW_SEAT_NUMBERS}
      },
      cartTitle(){
        if(!this.showSeatNumbers){return "Cart"}
        else{return "Cart: Adding for Seat #" + this.currentSeatNumber}
      }
    },
    methods:{
      incrementCurrentSeatNumber(){
        this.currentSeatNumber=this.currentSeatNumber +1
      },
      deccrementCurrentSeatNumber(){
        if(this.currentSeatNumber>1){
          this.currentSeatNumber=this.currentSeatNumber -1
        }
      },
      resetCurrentSeatNumber(){
        if(this.showSeatNumbers){
          this.currentSeatNumber=1
        }else{
          this.currentSeatNumber=0
        }
      },
      splitGuestClass(name){
        var cls = "splitGuestClass"
        if(name==this.selectedSplitGuest){
          cls="splitGuestClass selectedSplitGuestClass"
        }
        return cls
      },
      payTotal_byGuest(name){
        var pd = this.getGuestTotalPaid(name)
      
        return pd
      },
      due_byGuest(name){
         var pd = this.getGuestTotalPaid(name)
        var owed = this.getGuestTotal(name)
        var due = (Number(owed) - Number(pd)).toFixed(2)
        if(due<0){due='0.00'}
        return due
      },
      change_byGuest(name){
        var change=0
            if(this.ticket.paymentItems!=undefined){
              this.ticket.paymentItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.guestNumber==name ){
                        change = change + li.changeGiven
                    }
                } 
            }
            
               // console.log('gtotal ' + total)
            return change.toFixed(2)
      },
      startNewTicket(){
        this.ticket.id=0
        
        this.$store.dispatch('setIsNewTicket',true);
        this.$store.dispatch('startOver');

        //culinary specific resets
        this.tableNumber_Culinary=null
        if(this.IsAdmin){
          this.employee_Culinary={id:0,name:null}
        }else{
          this.employee_Culinary={id:this.loggedInUser.user_personId,name:this.loggedInUser.name}
        }
        this.selectedSplitGuest=null

        this.getEmployeeList_Culinary()


         
        //type reset
       this.resetTypeSelection()

       //reset seat number
        this.resetCurrentSeatNumber() //set for new ticket
        this.$nextTick(() => {
                this.refreshticket(true)
              })
      },
      resetTypeSelection(){
         if(this.availableCartItemTypes.length>0){
          this.availableCartItemTypes.forEach(myFunction2) 
            function myFunction2(item, index, arr) {
                let li=arr[index]
                li.selected=false
            } 
            this.selectedCartItemType=this.availableCartItemTypes[0].id
            this.availableCartItemTypes[0].selected=true
          }else{this.selectedCartItemType=0}
      },
        allItemsInKitchen(t=null){
            var allIn =true

            //if no ticket given, use current selected
            if(t==null){
              if(this.ticket.lineItems!=undefined){
                this.ticket.lineItems.forEach(myFunction2)
              
                  function myFunction2(item, index, arr) {
                      let li=arr[index]
                      if(!li.isInKitchen && li.productIsFireable){
                          allIn=false
                      }
                  } 
              }
            }else{
              if(t.lineItems!=undefined){
                t.lineItems.forEach(myFunction2)
              
                  function myFunction2(item, index, arr) {
                      let li=arr[index]
                      if(!li.isInKitchen && li.productIsFireable){
                          allIn=false
                      }
                  } 
              }
            }
            
            return allIn
          },
        selectTicketTypeCulinary(id,name){
            this.ticketType_Culinary=name
            this.tableNumber_Culinary=null
            this.guestName_Culinary=null
            /* this.employee_Culinary.id=0
            this.employee_Culinary.name=null */
         },
         selectTable(id,name){
            this.tableNumber_Culinary=name

            //if we aren't showing seating and BOTH are picked go straight to cart
            if(!this.showSeatGuests){
              if(this.employee_Culinary.id>0 && this.tableNumber_Culinary!=null && this.tableNumber_Culinary!=0){
                this.panels[0].valid = true;
                this.panels[1].available = true;
                
                this.panels[0].title =  "Table " + this.tableNumber_Culinary + " " + this.employee_Culinary.name
                this.AddTicket_Culinary(false)
              }
            }
            

         },
         changeGuestName(){
            this.panels[0].valid = true;
            this.panels[1].available = true;
            
            this.panels[0].title =  "Take Out: " + this.guestName_Culinary
            //this.panels[0].subtitle1="Guest " + this.guestName_Culinary
         },
         async getEmployeeList_Culinary(){
            let req = {
              ID:this.location.id
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'employee_culinary')
            //handle response
         
            if(response.Successful){
              this.employeeList_Culinary=response.ItemList
    
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
         },
         selectEmployeeCulinary(id,name){
        //  console.log('select2 ' + id + ' ' + name)
            this.employee_Culinary={
              id:id,
              name:name
            }

            //if we aren't showing seating and BOTH are picked go straight to cart
            if(!this.showSeatGuests){
              if(this.employee_Culinary.id>0 && this.tableNumber_Culinary!=null && this.tableNumber_Culinary!=0){
                this.panels[0].valid = true;
                this.panels[1].available = true;
                
                this.panels[0].title =  "Table " + this.tableNumber_Culinary + " " + this.employee_Culinary.name
                this.AddTicket_Culinary(false)
              }
            }

         },
         async AddTicket_Culinary(goToSeated=false, stayput=false){
      
          this.$store.dispatch('setIsNewTicket',false); 
 
          //if we already have a ticket (this came from reservation) - then just do the update part to add table and employee
            if(this.ticket.id>0){
              this.updateticket_culinary(goToSeated,stayput)

              return //don't add one
            }
         

            let req = {
              ticket:{
                guestId:null,
                businessDayId:this.businessDayId,
                locationId:this.location.id,
                terminalId:this.terminalId,
                employeeId:this.employee_Culinary.id,
                tableNumber:this.tableNumber_Culinary,
                takeoutGuestName:this.guestName_Culinary,
                isDineIn:this.ticketType_Culinary=='Dine In'

              }
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'addticket')
            //handle response
         
            if(response.Successful){
              
             
              if(goToSeated){
                var t = {id:response.ResponseInteger}
                this.seatTicket(t)
                return

              }else{
                this.ticket.id=response.ResponseInteger
                this.seatTicket_goToCart()
                return 
              }
              
              /* this.toNext();//
              this.$store.dispatch('startOver_Cart');
    
              this.$nextTick(() => {
                this.refreshticket(true)
              })
               */
              
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
          },

          async updateticket_culinary(goToSeated=false, stayput=false){
             let req = {
              ticket:{
                guestId:null,
                businessDayId:this.businessDayId,
                locationId:this.location.id,
                terminalId:this.terminalId,
                employeeId:this.employee_Culinary.id,
                tableNumber:this.tableNumber_Culinary,
                takeoutGuestName:this.guestName_Culinary,
                isDineIn:this.ticketType_Culinary=='Dine In',
                id:this.ticket.id
              }
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updateticket_culinary')
            //handle response
         
            if(response.Successful){
              if(stayput){
                //don't go anywhere
                this.pleaseWait=false;
                return
              }
              if(goToSeated){
                this.seatTicket()
                return
              }
              this.toNext();//
    
              this.$nextTick(() => {
                this.refreshticket()
              })
              
              
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
          },
          async seatTicket(inticket=null){
            var tickettosuspend = inticket
            if(tickettosuspend==null){tickettosuspend=this.ticket}
            console.log('inpay=true seatticket')
            this.inPayment=true
            let req = {
                ticket:tickettosuspend
              }
              //call api
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'seatticket')
              //handle response
          
              if(response.Successful){
                this.inPayment=false
                this.ticket.id=0
          
                this.$store.dispatch('startOver');
                 this.$nextTick(() => {
                  this.refreshticket(true)
                })
              }else{
                this.responseMessage = response.Message
              }
              this.inPayment=false
              this.pleaseWait=false;
          },
          async seatTicket_goToCart(inticket=null){
            var tickettosuspend = inticket
            if(tickettosuspend==null){tickettosuspend=this.ticket}
            console.log('inpay=true seatticket')
            this.inPayment=true
            let req = {
                ticket:tickettosuspend
              }
              //call api
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'seatticket')
              //handle response
          
              if(response.Successful){
                this.inPayment=false
                this.toNext();//
                this.$store.dispatch('startOver_Cart');
      
                this.$nextTick(() => {
                  this.refreshticket(true)
                })
              
              }else{
                this.responseMessage = response.Message
              }
              this.inPayment=false
              this.pleaseWait=false;
          },
          async addTip(amount){
        
            let req = {
                ticketTip:{
                  ticketId:this.ticket.id,
                  employeeId:this.ticket.employeeId,
                  amount:amount
                }
              }
              //call api
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'addtip')
              //handle response
          
              if(response.Successful){
                
                this.updateTotals();
              }else{
                this.responseMessage = response.Message
              }

              this.pleaseWait=false;
          },
          getGuestTotal(guestnumber){
            var total=0
            if(this.ticket.lineItems!=undefined){
              this.ticket.lineItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.guestNumber==guestnumber ){
                        total = total + li.amount + li.tax
                    }
                } 
            }
            
               // console.log('gtotal ' + total)
            return total.toFixed(2)
          },

          getGuestTotalPaid(guestnumber){
            var total=0
            if(this.ticket.paymentItems!=undefined){
              this.ticket.paymentItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.guestNumber==guestnumber ){
                        total = total + li.amount
                    }
                } 
            }
            
               // console.log('gtotal ' + total)
            return total.toFixed(2)
          },
          async UpdateLineItemGuestNumbers(){

         

            let req = {
              ticket:this.ticket
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updateticketlineitem_guestnumber')
            //handle response
         
            if(response.Successful){
           
            
              this.$nextTick(() => {
                this.refreshticket(true)
              })
              
              
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
          },
          async sendtickettokitchen(gotopay=false,thispanelIndex){
           //stash these for after kitchen is done
            this.payAfterToKitchen=gotopay
           this.payIndexAfterToKitchen=thispanelIndex
            this.$refs.tokitchen.Show()
          },
          /* async sendtickettokitchen(gotopay=false,thispanelIndex){
            this.inPayment=true
            console.log('inpay=true sendtickettokitchen')
            let req = {
                ticket:this.ticket
              }
              //call api
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'sendtickettokitchen')
              //handle response
          
              if(response.Successful){
                if(gotopay){
                  this.inPayment=false
                  var nextPanelIndex = Number(thispanelIndex) + 1;
                  this.$store.dispatch('setActivePanel',nextPanelIndex);
                }else{
                  this.inPayment=false
                  //start over
                  this.$store.dispatch('startOver');
                }
                
              }else{
                this.responseMessage = response.Message
              }
              this.pleaseWait=false;
              this.inPayment=false
          }, */
          async GetPrepAreas(){

            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(null,'prepareasactive')
            //handle response
         
            if(response.Successful){
           
              this.prepAreas=response.ProductPrepAreaList
              
              
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
          },
          setCurrentTicket(ticket){
            this.ticket=ticket
          },
          async sendItemsToKitchen(){
            this.inPayment=true
            console.log('inpay=true sendtickettokitchen')
            let req = {
                ticket:this.ticket
              }
              //call api
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'senditemstokitchen')
              //handle response
          
              if(response.Successful){
                if(this.payAfterToKitchen){
                  //use what we stored
                  this.inPayment=false
                  this.ticket.statusName="InKitchen"
                  var nextPanelIndex = Number(this.payIndexAfterToKitchen) + 1;
                  this.$store.dispatch('setActivePanel',nextPanelIndex);
                }else{
                  this.inPayment=false
                  //start over
                  this.ticket.id=0//????
                  this.$store.dispatch('startOver');
                   
                }

                  
                
              }else{
                this.responseMessage = response.Message
              }
              this.pleaseWait=false;
              this.inPayment=false
          },
          async printTicketDirect(id,printOnlyToFire=false){
            
              let req = {
                  ticketId:id,
                  guestNumber:null,
                  prepAreas:this.prepAreas,
                  printOnlyToFire:printOnlyToFire
                } 
                if(id<=0){
                  req.ticket=this.ticket
                } 
                  //call api
                  this.$store.dispatch('beforeAPI');
                  var response = await this.callAPI(req,'ticket_direct')
                  //handle response
              
                  if(response.Successful){
                    return response.ReceiptPrintJob
                    
                  }else{
                    this.responseMessage = response.Message
                  }
                  this.pleaseWait=false
          }
        
        
              
    }

}

